import { render, staticRenderFns } from "./approvalDeletePopup.vue?vue&type=template&id=4b5fe4b4&scoped=true&"
import script from "./approvalDeletePopup.vue?vue&type=script&lang=js&"
export * from "./approvalDeletePopup.vue?vue&type=script&lang=js&"
import style0 from "./approvalDeletePopup.vue?vue&type=style&index=0&id=4b5fe4b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fe4b4",
  null
  
)

export default component.exports